import { SERVICE_PROVIDERS } from 'modules/graphql';
import { displayDate, DATE_FORMAT_FULL } from 'utils/date';
import {
  USERS,
  CUSTOM_EVENTS_STORED,
  CURRENT_USERS,
  CURRENT_CUSTOM_EVENTS_STORED,
  SMS_SEGMENTS_SENT,
  SMS_SEGMENTS_TOTAL,
  SMS_SEGMENTS_RECEIVED,
  MMS_ATTACHMENTS_TOTAL,
  MMS_ATTACHMENTS_RECEIVED,
  MMS_ATTACHMENTS_SENT,
  SUCCESSFUL_SMS_VERIFICATIONS,
  ITERABLE_SMS,
  TELNYX_DIRECT,
  TWILIO_DIRECT,
} from '../constants';
import { Metric } from '../types';

export const billingPartyText = (metric: Metric) => {
  const { billingParty, providerName } = metric;
  if (billingParty === 'ThirdParty' && providerName === SERVICE_PROVIDERS.TWILIO)
    return TWILIO_DIRECT;
  if (billingParty === 'ThirdParty' && providerName === SERVICE_PROVIDERS.TELNYX)
    return TELNYX_DIRECT;
  if (billingParty === 'FirstParty') return ITERABLE_SMS;
  /** This final return case should never be hit -- billingParty can also
   * be "Unknown" but those metrics should be filtered out before this method
   * is invoked. The case is just here for failover.
   */
  return `${providerName} ${billingParty}`;
};

export const MESSAGING_FIELDS_ORDERING: Record<string, number> = {
  [SMS_SEGMENTS_SENT]: 0,
  [SMS_SEGMENTS_RECEIVED]: 1,
  [SMS_SEGMENTS_TOTAL]: 2,
  [MMS_ATTACHMENTS_SENT]: 3,
  [MMS_ATTACHMENTS_RECEIVED]: 4,
  [MMS_ATTACHMENTS_TOTAL]: 5,
  [SUCCESSFUL_SMS_VERIFICATIONS]: 6,
};

export const messagingFieldsOrdering = (metric: string) =>
  MESSAGING_FIELDS_ORDERING[metric] !== undefined ? MESSAGING_FIELDS_ORDERING[metric] : -1;

export const remapCurrentMetrics = (metrics: Metric[] = []) =>
  /**
   * Because the "current" metrics are just metrics retrieved via a second
   * API call with the query dates changed, we renmae their metricNames here
   * to feed into the display functions further down the chain.
   */
  metrics
    .filter((metric) => [USERS, CUSTOM_EVENTS_STORED].includes(metric.metricName))
    .map((metric: Metric) => {
      let { metricName } = metric;
      if (metric.metricName === USERS) metricName = CURRENT_USERS;
      if (metric.metricName === CUSTOM_EVENTS_STORED) metricName = CURRENT_CUSTOM_EVENTS_STORED;
      return { ...metric, metricName };
    });

export const createHighWatermarkCaption = (metric: Metric) => {
  const highWatermarkDate = (metric as Metric)?.metadata?.highWatermarkDate;
  return highWatermarkDate ? displayDate(highWatermarkDate, DATE_FORMAT_FULL) : '';
};
